import {
    AllWalletTabType,
    RawWalletTransactionsResponse,
    WalletTransactionsResponse
} from '@/src/types/wallet'
import {
    getCleartripTotalRecords,
    mapCleartripRawTransaction,
    mapRawTransaction
} from '@/src/utils/wallet/transactionMapper'

export const getWalletRequestOffset = ({
    isCleartripBrand,
    offset,
    size
}: {
    isCleartripBrand: boolean
    offset: number
    size: number
}): number => {
    // Cleartrip uses row-based offset (1, 11, 21...), Flyin uses page number.
    return isCleartripBrand ? (offset - 1) * size + 1 : offset
}

export const shouldSendWalletTypeParam = ({
    isCleartripBrand,
    type
}: {
    isCleartripBrand: boolean
    type: AllWalletTabType
}): boolean => {
    // Cleartrip ALL tab does not use type param. Flyin sends type except ALL.
    return !isCleartripBrand && type !== 'ALL'
}

export const transformCleartripWalletTransactions = ({
    rawTransactions,
    remainingCount,
    offset,
    size
}: {
    rawTransactions: unknown
    remainingCount: number
    offset: number
    size: number
}): WalletTransactionsResponse => {
    const transactions = Array.isArray(rawTransactions) ? rawTransactions : []
    const mappedTransactions = transactions.map(mapCleartripRawTransaction)
    const totalRecords = getCleartripTotalRecords({
        offset,
        size,
        pageCount: mappedTransactions.length,
        remainingCount
    })

    return {
        status: 'SUCCESS',
        transactions: mappedTransactions,
        totalRecords: Math.max(totalRecords, 0)
    }
}

export const transformFlyinWalletTransactions = (
    response: RawWalletTransactionsResponse | any
): WalletTransactionsResponse => {
    const rawList = response?.transactions
    const total = response?.totalRecords ?? 0

    return {
        status: 'SUCCESS',
        transactions: (rawList ?? []).map(mapRawTransaction),
        totalRecords: total
    }
}
